import { useEffect } from "react";

export function usePreloadAudioUrls(urls: Array<string | undefined | null>) {
  useEffect(() => {
    const audioElements = urls
      .map((url) => (typeof url === "string" ? url.trim() : ""))
      .filter(
        (url, index, values) => Boolean(url) && values.indexOf(url) === index,
      )
      .map((url) => {
        const audio = new Audio();
        audio.crossOrigin = "anonymous";
        audio.preload = "auto";
        audio.src = url;
        audio.load();
        return audio;
      });

    return () => {
      for (const audio of audioElements) {
        audio.pause();
        audio.removeAttribute("src");
        audio.load();
      }
    };
  }, [urls]);
}
